import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

type PageFooterProps = {
  className?: string;
  children: ReactNode;
  rightColumn?: ReactNode;
  showRightColumnOnMobile?: boolean;
};

const PageFooter = ({
  children,
  className,
  rightColumn,
  showRightColumnOnMobile,
}: PageFooterProps) => {
  return (
    <section
      className={cn(
        "border-gray-150 w-full border-t md:grid md:grid-cols-12",
        className,
      )}
    >
      <div className="border-gray-150 px-5 py-6 md:col-span-6 md:border-r lg:col-span-7 lg:p-10 xl:col-span-8">
        {children}
      </div>
      {rightColumn && (
        <div
          className={cn(
            "flex flex-col gap-y-4 px-5 py-6 md:col-span-6 lg:col-span-5 lg:gap-y-8 lg:p-10 xl:col-span-4",
            !showRightColumnOnMobile && "max-sm:hidden",
          )}
        >
          {rightColumn}
        </div>
      )}
    </section>
  );
};

PageFooter.displayName = "PageFooter";

export default PageFooter;
